import Collapse from "@mui/material/Collapse";
import List from "@mui/material/List";
import * as React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faChevronDown, faChevronUp} from "@fortawesome/free-solid-svg-icons";
import {useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import {createModal} from "../../utils/modal";
import {guardSoldOutInteraction, isProductSoldOut, TranslatedAttribute} from "../../../../utils";
import {productResourcePrice} from "../../../../helpers/price_handler";

const LABEL_STYLES = {
  new: 'bg-green-100 text-green-800',
  star: 'bg-amber-100 text-amber-800',
  chefs_suggestion: 'bg-purple-100 text-purple-800',
};

const CollapseHead = ({item, extraStyle = 'bg-[#d3ece9]'}) => {

  const {currencySymbol, locale, soldOutProductIds} = useSelector(state => state.app);
  const {t} = useTranslation();
  const [open, setOpen] = React.useState(false);
  const itemSoldOut = isProductSoldOut(item, soldOutProductIds);

  const handleClick = () => {
    setOpen(!open);
  };

  return (
    <div className={`w-full bg-[#d3ece9] rounded-[25px] mb-3 mx-auto`}>
      <div className={'p-[15px] flex justify-between items-center' + (itemSoldOut ? ' opacity-50' : '')} onClick={handleClick}>
        <div key={item.id}
             className={`w-full font-bold text-[#555] flex flex-row justify-between items-center grid grid-cols-12 gap-4`}
             onClick={() => {
               if (item.resource_type === 'Product' && (item.sub_items?.length || 0) === 0) {
                 if (guardSoldOutInteraction(item)) return;
                 createModal('no_image_product_detail', item)
               }
             }}>
          <div className={'col-span-8'}>
            <span>{TranslatedAttribute(locale, item, 'name')}</span>
            <p className={'text-[12px] font-normal line-clamp-2'}>{TranslatedAttribute(locale, item, 'description')}</p>
            {itemSoldOut && (
              <div className={'flex flex-row flex-wrap gap-1 mt-1'}>
                <span className={'text-[10px] font-semibold px-2 py-0.5 rounded-full bg-red-100 text-red-800'}>
                  {t('general.sold_out')}
                </span>
              </div>
            )}
            {item.labels && item.labels.length > 0 && (
              <div className={'flex flex-row flex-wrap gap-1 mt-1'}>
                {item.labels.map((label) => (
                  <span key={label} className={`text-[10px] font-semibold px-2 py-0.5 rounded-full ${LABEL_STYLES[label] || 'bg-gray-100 text-gray-700'}`}>
                    {t(`labels.${label}`)}
                  </span>
                ))}
              </div>
            )}
          </div>
          <div className={'col-span-4 text-right'}>
            {
              (item.resource_type === 'Product' || (item.resource_type === null && item.item_type === 'product')) && (item.sub_items?.length || 0) === 0 ? (productResourcePrice(item).toString().includes('-') ? productResourcePrice(item) : `${parseFloat(productResourcePrice(item)).toFixed(2)} ${currencySymbol}`) : ''
            }
          </div>
        </div>
        <div className={'ml-3'}>
          {
            item.sub_items && (item.sub_items?.length || 0) > 0 ? (
              open ?
                <FontAwesomeIcon icon={faChevronUp} color={'#92a09f'}/>
                :
                <FontAwesomeIcon icon={faChevronDown} color={'#92a09f'}/>
            ) : (<></>)
          }
        </div>
      </div>
      {
        item.sub_items && (item?.sub_items?.length || 0) > 0 ? (
          <Collapse in={open} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <div className={`p-3 flex justify-between rounded-[25px] m-1 ${extraStyle}`}>
                <div className={'w-full flex flex-col'}>
                  {
                    item.sub_items && (item?.sub_items?.length || 0) > 0 ? (
                      item.sub_items.map(subItem => {
                          const subItemSoldOut = isProductSoldOut(subItem, soldOutProductIds);
                          return subItem.sub_items && (subItem?.sub_items?.length || 0) > 0 ?
                            <CollapseHead key={subItem.id} item={subItem} extraStyle={'bg-[#f2f9f8] text-sm'}/>
                            :
                            <div key={subItem.id}
                                 className={`relative grid grid-cols-12 gap-4 font-bold text-sm text-[#555] rounded-[25px] p-2 block flex flex-row justify-between ${extraStyle}` + (subItemSoldOut ? ' opacity-50' : '')}
                                 onClick={() => {
                                   if (guardSoldOutInteraction(subItem)) return;
                                   createModal('no_image_product_detail', subItem)
                                 }}>
                              <div className={'col-span-8'}>
                                <span>{TranslatedAttribute(locale, subItem, 'name')}</span>
                                <p
                                  className={'text-[12px] font-normal line-clamp-2'}>{TranslatedAttribute(locale, subItem, 'description')}</p>
                                {subItemSoldOut && (
                                  <div className={'flex flex-row flex-wrap gap-1 mt-1'}>
                                    <span className={'text-[10px] font-semibold px-2 py-0.5 rounded-full bg-red-100 text-red-800'}>
                                      {t('general.sold_out')}
                                    </span>
                                  </div>
                                )}
                                {subItem.labels && subItem.labels.length > 0 && (
                                  <div className={'flex flex-row flex-wrap gap-1 mt-1'}>
                                    {subItem.labels.map((label) => (
                                      <span key={label} className={`text-[10px] font-semibold px-2 py-0.5 rounded-full ${LABEL_STYLES[label] || 'bg-gray-100 text-gray-700'}`}>
                                        {t(`labels.${label}`)}
                                      </span>
                                    ))}
                                  </div>
                                )}
                              </div>
                              <div
                                className={'col-span-4 text-right'}>{(productResourcePrice(subItem).toString().includes('-') ? productResourcePrice(subItem) : `${parseFloat(productResourcePrice(subItem)).toFixed(2)} ${currencySymbol}`)}</div>
                            </div>
                        }
                      )
                    ) : (<></>)
                  }
                </div>
              </div>
            </List>
          </Collapse>
        ) : (<></>)
      }

    </div>
  )
}

export default CollapseHead;